/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { responsesPartMeta } from '../models/responsesPartMeta';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SystemProcessesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * create an empty company
   * @param requestBody
   * @returns any details about the created company
   * @throws ApiError
   */
  public postApiServicesecurityProcessesSystemSetupCompany(
    requestBody?: {
      company: {
        name: string;
        brand: {
          logoUrl: string;
          websiteUrl: string;
          colors: {
            primary?: string;
            secondary?: string;
          };
        };
      };
      opensignup: {
        enabled?: boolean;
        allowedDomains?: Array<string>;
      };
    },
  ): CancelablePromise<{
    data?: {
      sent?: boolean;
      uuid?: string;
      name?: string;
      slug?: string;
      brand?: {
        logoUrl: string;
        websiteUrl: string;
        colors: {
          primary?: string;
          secondary?: string;
        };
      };
      welcomeContent?: {
        message?: string;
      };
      helpContent?: {
        message?: string;
      };
      onboardingContent?: {
        message?: string;
      };
      invitationMessage?: {
        invitationEmailEnabled?: boolean;
        invitationSmsEnabled?: boolean;
        email?: {
          subject: string;
          content: string;
        };
        sms?: {
          content: string;
        };
      };
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/system/setup-company',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * create an empty enterprise
   * @param requestBody
   * @returns any details about the created enterprise
   * @throws ApiError
   */
  public postApiServicesecurityProcessesSystemSetupEnterprise(
    requestBody?: {
      enterprise: {
        name: string;
        brand: {
          logoUrl: string;
          websiteUrl: string;
          colors: {
            primary?: string;
            secondary?: string;
          };
        };
      };
      adminEmail: string;
    },
  ): CancelablePromise<{
    data?: {
      adminUuid?: string;
      enterprise?: {
        sent?: boolean;
        uuid?: string;
        name?: string;
        slug?: string;
        brand?: {
          logoUrl: string;
          websiteUrl: string;
          colors: {
            primary?: string;
            secondary?: string;
          };
        };
      };
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/system/setup-enterprise',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * upgrade an enterprise identity user to a super user
   * @param requestBody
   * @returns any Users successfully upgraded to super users
   * @throws ApiError
   */
  public postApiServicesecurityProcessesSystemUpgradeToSuperUser(
    requestBody?: {
      enterpriseIdentityUuids: Array<string>;
      superUserRoleUuid: string;
    },
  ): CancelablePromise<{
    data?: {
      success?: boolean;
      superUserUuids?: Array<string>;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/system/upgradeToSuperUser',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

}
